import React from 'react';

const Emergency = () => {
  return (
    <div className="emergency2-main-wrapper float_left">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-12 col-sm-12 col-12 p-0">
            <div className="video-section">
              <div data-bs-toggle="modal" data-bs-target="#videoModal">
                <div className="wrapper">
                  <div className="waves-block">
                    <div className="waves wave-1"></div>
                    <div className="waves wave-2"></div>
                    <div className="waves wave-3"></div>
                  </div>
                </div>
                <img src="images/video-icon.png" alt="Play Video" />
              </div>

              {/* Modal */}
              <div
                className="modal fade"
                id="videoModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <button type="button" data-bs-dismiss="modal">
                      <i className="fas fa-times"></i>
                    </button>
                    <div className="modal-body p-0">
                      <iframe
                        width="100%"
                        height="315"
                        src="https://www.youtube.com/embed/8jd9YnoekiI"
                        title="YouTube video player"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8 col-md-12 col-sm-12 col-12 p-0">
            <div className="sb-emergency-section">
              <div className="content">
                <span><i className="fas fa-headphones-alt"></i></span>
                <h4>Emergency <br /> Medical Care 24/7</h4>
              </div>
              <p>
                With access to 24 hour emergency assistance, It’s so important you
                <br /> can continue to help others.
              </p>
              <div className="content">
                <span><i className="fas fa-phone"></i></span>
                <h4>+888 7987542334</h4>
              </div>
              <img
                src="images/emergency2.png"
                className="d-none d-md-block d-lg-block d-xl-block"
                alt="Emergency"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Emergency;
